'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeAddress = exports.getAddressDetails = exports.searchAddress = undefined;

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var searchAddress = exports.searchAddress = function searchAddress() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'au';

  var params = { q: query, country_code: region };

  return (0, _client.get)('api/v2/addresses', params).then(function (data) {
    return data.addresses;
  });
};

var getAddressDetails = exports.getAddressDetails = function getAddressDetails() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'au';

  return (0, _client.get)('api/v2/addresses/' + region + '/' + id).then(function (data) {
    return data.address;
  });
};

var deserializeAddress = exports.deserializeAddress = function deserializeAddress(address) {
  return {
    streetAddress: address.street_address,
    extendedAddress: address.extended_address,
    locality: address.locality,
    region: address.region,
    postCode: address.postal_code
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/address/everydayhero/index.js
// module id = 1396
// module chunks = 0